import { http } from 'services'
// initial state
const state = () => ({
  all: [],
  active: {},
  errors: null
})

// getters
const getters = {
}

// actions
const actions = {
  ['externalEmail.getAll'] ({ commit }) {
    commit('CLEAR_ERRORS')

    return (http.get(`external-emails?_all=true`)).then ((res) => {
      commit('GET_ALL_EXTERNAL_EMAILS', res);
    })
    .catch ((res) => {
      commit('EXTERNAL_EMAILS_ERROR', res);
    })
  },
  ['externalEmail.new'] ({ commit , dispatch}, data) {
    commit('CLEAR_ERRORS')

    return (http.post(`external-emails`, data))
    .then ((res) => {
      dispatch('externalEmail.getAll');
    })
    .catch ((res) => {
      commit('EXTERNAL_EMAILS_ERROR', res);
    })
  },

  ['externalEmail.edit'] ({ commit }, {id, data}) {
    commit('CLEAR_ERRORS')

    return (http.put(`external-emails/${id}`, data))
    .then ((res) => {
      commit('EDIT_EXTERNAL_EMAIL', res);
    })
    .catch ((res) => {
      commit('EXTERNAL_EMAILS_ERROR', res);
    })
  },

  ['externalEmail.remove'] ({ commit }, data) {
    commit('CLEAR_ERRORS')

    return (http.delete(`external-emails/${data.id}`))
    .then ((res) => {
      commit('REMOVE_EXTERNAL_EMAIL', data.id);
    })
    .catch ((res) => {
      commit('EXTERNAL_EMAILS_ERROR', res);
    })
  },

}

// mutations
const mutations = {
  GET_ALL_EXTERNAL_EMAILS (state, res) {
    state.all = res.data;
  },

  GET_EXTERNAL_EMAIL (state, res) {
    state.active = res.data
  },

  REMOVE_EXTERNAL_EMAIL (state, id) {
    state.all = _.filter(state.all, (item) => item.id != id);
  },

  EDIT_EXTERNAL_EMAIL (state, res) {
    state.active = res.data
  },

  //ERRORS
  EXTERNAL_EMAILS_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}



export default {
  state,
  getters,
  actions,
  mutations
}
